import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'about-us',
    templateUrl: './about-us.component.html'
})
export class AboutUsComponent implements OnInit {

    constructor(@Inject(DOCUMENT) public document: Document) {
    }

    ngOnInit(): void {
    }
}
